import { RootState } from 'store';

import { useSelector } from 'react-redux';

import { DRIVERS_STATE } from '../../constants';

export const useSelectedDriverFuelAssignment = () => {
  const selectedDriverFuelAssignment = useSelector((state: RootState) => state[DRIVERS_STATE].selectedFuelAssignment);
  return selectedDriverFuelAssignment;
};
